import * as yup from 'yup';
import docs from './attachments';
import { foiJulgado } from './utils/rulesByKey';

export const RevisaoCPASchema = yup.object({
  tempoContribuicaoINSS: yup
    .string()
    .oneOf(['Sim', 'Não'])
    .required(
      'Atenção, Selecione a opção Tempo de contribuição acrescido pelo INSS?'
    ),
  revisaoProcessoJudicial: yup.string().when('tempoContribuicaoINSS', {
    is: 'Sim',
    then: (field) =>
      field
        .oneOf(['Sim', 'Não'])
        .required(
          'Atenção, Selecione a opção Revisão originária de processo judicial?'
        ),
  }),
  ...foiJulgado(),
  ...docs.RevisaoCPADocs.rules,
});

export const RevisaoCPAInitialValues = {
  tempoContribuicaoINSS: '',
  revisaoProcessoJudicial: '',
  foiJulgado: '',
  ...docs.RevisaoCPADocs.initialValues,
};

export const RevisaoCPADocs = docs.RevisaoCPADocs.docs;
